import { useTranslation } from "react-i18next";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { changeLanguage, SupportedLanguage } from "config/i18n";

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();

  const handleChange = (
    _: React.MouseEvent<HTMLElement>,
    lang: SupportedLanguage | null,
  ) => {
    if (lang) changeLanguage(lang);
  };

  return (
    <ToggleButtonGroup
      value={i18n.language}
      exclusive
      onChange={handleChange}
      size="small"
      aria-label={t("language.switch")}
    >
      <ToggleButton value="pl">{t("language.pl")}</ToggleButton>
      <ToggleButton value="en">{t("language.en")}</ToggleButton>
    </ToggleButtonGroup>
  );
}
